import React from "react";

import useNavigation from "./hooks/useNavigation";

import SchoolNavigationDesktop from "./desktop/SchoolNavigationDesktop";
import SchoolNavigationMobile from "./mobile/SchoolNavigationMobile";

const SchoolNavigation = (props) => {
  const {
    isNavigationMobile
  } = useNavigation();

  if (isNavigationMobile) {
    return <SchoolNavigationMobile {...props} />;
  }

  return <SchoolNavigationDesktop {...props} />;
};

export default SchoolNavigation;